import { FieldValidator } from './field-validator'
import * as _ from 'lodash'

export class ZipTextFieldValidator implements FieldValidator<string> {
    constructor(private allowsBlank = false) {}

    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (this.allowsBlank && _.isEmpty(text)) {
                resolve('')
            }

            let regexVal = new RegExp('[0-9]{5}');
            let isZipCodeValid = regexVal.test(text);

            if (isZipCodeValid) {
                resolve('')
            } else {
                reject(`${fieldName} must be a five digit number`)
            }
        })
    }
}
